import { useMediaQuery } from "@mui/material";
import WebView from "./PricingWebView";
import MobileView from "./PricingMobileView";
export default function PricingPage() {
  const isSmallScreen = useMediaQuery("(max-width:960px)");
  return <>{isSmallScreen ? <MobileView /> : <WebView />}</>;
}
